import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { ToastContainer, toast } from "react-toastify";
import MaterialTable from "material-table";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import Select from "react-select";
import ApprovalAction from "./ApprovalAction";



function ViewApproval() {

    const { state: requestId } = useLocation();
    const navigate = useNavigate();
    const [request, setRequest] = useState(null);
    const [history, setHistory] = useState([]);
    const [comment, setComment] = useState("");
    const [users, setUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [isEditMode, setIsEditMode] = useState(false);
    const latestComment = history?.[0]?.comment || "-";
    const labelStyle = { width: "35%" };
    const fieldStyle = { width: "55%" };

    useEffect(() => {

        if (!requestId) {
            navigate("/approvals");
            return;
        }

        axios.get(API + `approvals/request/${requestId}/`, {
            headers: authHeader()
        }).then(async res => {

            setRequest(res.data)
            setHistory(res.data.history || [])
        });

        axios.get(API + "approvals/users/", {
            headers: authHeader()
        }).then(res => setUsers(res.data))

    }, [requestId, navigate]);


    useEffect(() => {

        if (!request || !users.length) return;
        // set selected reassigned user correctly
        const user = users.find(u => u.username === request.assigned_user);
        if (user) {
            setSelectedUser(user.id);
        }
    }, [request, users]);

    const reloadData = async () => {
        const res = await axios.get(API + `approvals/request/${requestId}/`, {
            headers: authHeader()
        });

        setRequest(res.data);
        setHistory(res.data.history || []);
    };

    const approve = async () => {

        try {

            await axios.post(
                API + `approvals/approve/${request.id}/`,
                { comment },
                { headers: authHeader() }
            );

            toast.success("Approved");

            setTimeout(() => window.location.reload(), 1200);

        } catch {
            toast.error("Approval failed");
        }

    };


    const reject = async () => {

        try {

            await axios.post(
                API + `approvals/reject/${request.id}/`,
                { comment },
                { headers: authHeader() }
            );

            toast.success("Rejected");

            setTimeout(() => window.location.reload(), 1200);

        } catch {
            toast.error("Reject failed");
        }

    };


    const saveReassign = async () => {

        if (!selectedUser) {
            toast.error("Please select a user");
            return;
        }

        try {

            await axios.post(
                API + `approvals/reassign/${request.id}/`,
                {
                    user: selectedUser,
                    comment: comment
                },
                { headers: authHeader() }
            );

            toast.success("Request Updated");

            // reload request to update history
            const res = await axios.get(
                API + `approvals/request/${requestId}/`,
                { headers: authHeader() }
            );

            setRequest(res.data);
            setHistory(res.data.history || []);

        } catch {

            toast.error("Reassign failed");

        }

    };


    if (!request) {

        return (
            <ContentLoader viewBox="0 0 400 160">
                <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            </ContentLoader>
        );
    }

    return (
        <div className="page-wrapper">

            <ToastContainer />

            <div className="container-fluid">

                {/* HEADER */}

                <div className="header pt-3">
                    <h5>Approval</h5>
                    <h6>
                        <Link to="/approvals">Approvals</Link> / View Approval
                    </h6>
                </div>


                <div className="row">

                    <div className="row">
                        <div className="col-6">
                            <div className="card">
                                <div className="card-body">

                                    <div className="row">

                                        {/* LEFT SIDE */}


                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-6 col-form-label">Approval Number</label>
                                                <p className="view-label p">{request.request_id}</p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-6 col-form-label">Transaction Number</label>
                                                <span
                                                    className="view-label hyperlink"
                                                    style={{ fontSize: 12, cursor: "pointer" }}
                                                    onClick={() => {
                                                        const routeMap = {
                                                            manual: "/viewmanualaccounting",
                                                            expense: "/expenses/view",
                                                            invoice: "/billing/view",
                                                            receipt: "/receipts/editreceipts"
                                                        };

                                                        const type = request?.transaction_type?.toLowerCase();
                                                        const path = routeMap[type];

                                                        if (path) {
                                                            navigate(path, { state: request.transaction_id });
                                                        } else {
                                                            console.warn("Unknown transaction type 👉", type);
                                                        }
                                                    }}
                                                >
                                                    {request?.transaction_number || "-"}
                                                </span>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-5 col-form-label">WorkFlow</label>
                                                <p className="col-7 view-label p mb-0">
                                                    {request?.workflow || "-"}
                                                </p>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-6 col-form-label">Requested By</label>
                                                <p className="view-label p">{request?.requested_by || "-"}</p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-6 col-form-label">Request Date</label>
                                                <p className="view-label p">
                                                    {Helper.DateNormal(request.request_date)}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-6 d-flex">
                                                <label className="col-6 col-form-label">Status</label>
                                                <p className="view-label p">
                                                    {request.status}
                                                </p>
                                            </div>
                                        </div>




                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-6">

                            <ApprovalAction request={request} onSuccess={reloadData} />

                        </div>
                    </div>
                </div>


                {/* ACTION BUTTONS */}

                <div className="text-left py-3">

                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate("/approvals")}
                    >
                        Cancel
                    </button>

                    &nbsp;&nbsp;



                    {/* <button
                        className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                        onClick={approve}
                    >
                        Approve
                    </button>

                    &nbsp;&nbsp;

                    <button
                        className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                        onClick={reject}
                    >
                        Reject
                    </button> */}

                </div>

                {/* HISTORY TABLE */}

                <div className="row">
                    <div className="col-xl-12">
                        <div className="row">

                            <label
                                className="col-lg-5 mt-2 col-form-label"
                                style={{ color: "#000000" }}
                            >
                                <h5>{t("Approval History")}</h5>
                            </label>

                            <div className="col-lg-12 mt-1">
                                <div className="body">
                                    <div className="table-responsive p-0">
                                        <MaterialTable
                                            style={{
                                                padding: "0.5rem",
                                                backgroundColor: "var(--bs-table-bg)",
                                                borderBottomWidth: "1px",
                                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                            }}

                                            columns={[
                                                {
                                                    title: "Date",
                                                    render: row => Helper.DateNormal(row.date),
                                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                    cellStyle: { fontSize: 12 },
                                                },
                                                {
                                                    title: "User",
                                                    field: "user",
                                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                    cellStyle: { fontSize: 12 },
                                                },
                                                {
                                                    title: "Action",
                                                    field: "action",
                                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                    cellStyle: { fontSize: 12 },
                                                },
                                                {
                                                    title: "Comment",
                                                    field: "comment",
                                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                    cellStyle: { fontSize: 12 },
                                                }
                                            ]}

                                            data={history}

                                            options={{
                                                headerStyle: {
                                                    backgroundColor: "white",
                                                    color: "#245C7F",
                                                    fontSize: 11,
                                                },
                                                rowStyle: (rowData, index) =>
                                                    index % 2 ? { backgroundColor: "#fff" } : {},
                                                sorting: true,
                                                search: false,
                                                toolbar: false,
                                                paging: true,
                                                pageSize: 10,
                                                emptyRowsWhenPaging: false,
                                                pageSizeOptions: [10, 20, 25, 50],
                                                paginationType: "stepped",
                                                showFirstLastPageButtons: false,
                                            }}

                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>




            </div>

        </div >
    );
}

export default ViewApproval;